export function getImplicitHydrogensCount(molecule, atomID) {
    molecule.ensureHelperArrays(molecule.getOCL().Molecule.cHelperNeighbours);
    return (molecule.getAllHydrogens(atomID) +
        molecule.getConnAtoms(atomID) -
        molecule.getAllConnAtoms(atomID));
}
//# sourceMappingURL=getImplicitHydrogensCount.js.map